import classnames from 'classnames';

/**
 * Generalized tokenized payment method component
 * Can be used by any payment integration (Fastlane, Google Pay, etc.)
 */
export const TokenizedPaymentMethod = ({
    icon,
    description,
    actions = [],
    className = ''
}) => {
    return (
        <div className={classnames('wc-ppcp-tokenized-card', className)}>
            {icon && (
                <CardIcon icon={icon}/>
            )}
            <div className="wc-ppcp-tokenized-card-format">
                {description}
            </div>
            {actions.length > 0 && (
                <div className="wc-ppcp-tokenized-card-actions">
                    {actions.map((action, index) => (
                        <a
                            key={index}
                            className={`wc-ppcp-tokenized-card-${action.type || 'action'}`}
                            onClick={action.onClick}>
                            {action.label}
                        </a>
                    ))}
                </div>
            )}
        </div>
    )
}

const CardIcon = ({icon}) => {
    return (
        <div className="wc-ppcp-tokenized-card-icon-container">
            <img src={icon.src} alt={icon.alt || ''}/>
        </div>
    )
}

export default TokenizedPaymentMethod;